export default __webpack_public_path__ + "static/media/computer.0606fd29.svg";